import { render, staticRenderFns } from "./ReportSummaryCHBACCNew.vue?vue&type=template&id=2c1bfa20"
import script from "./ReportSummaryCHBACCNew.vue?vue&type=script&lang=js"
export * from "./ReportSummaryCHBACCNew.vue?vue&type=script&lang=js"
import style0 from "./ReportSummaryCHBACCNew.vue?vue&type=style&index=0&id=2c1bfa20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports